import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.522 13.03a.817.817 0 0 1-.82.82h-8.01a.82.82 0 1 1 0-1.64H10.7a.824.824 0 0 1 .822.82Zm3.14.36a.749.749 0 0 1-.66.39.719.719 0 0 1-.35-.08 2.9 2.9 0 0 1-1.4-1.67c-.05-.24-.22-.83-.41-1.52h-8.3a1.7 1.7 0 0 1-1.7-1.7V3.95a1.7 1.7 0 0 1 1.7-1.7h4.05a1.693 1.693 0 0 1 1.66 1.31l1.29 5.45h.88c-.23-.83-.42-1.5-.43-1.52a.749.749 0 1 1 1.44-.41c.04.15 1.11 3.88 1.28 4.61.06.28.46.58.65.69a.742.742 0 0 1 .3 1.01ZM9 9.01 7.792 3.9a.2.2 0 0 0-.2-.15h-4.05a.2.2 0 0 0-.2.2v4.86a.2.2 0 0 0 .2.2ZM6.972 4.38h-2.71v1.04h3Z';
const draw24px =
  'M21.69,19.42a2.68,2.68,0,0,1-1.23-1.36c-.26-1.14-1.94-7-2-7.23a.75.75,0,1,0-1.44.41s.4,1.4.83,2.94H15.56L13.45,5.27a2.25,2.25,0,0,0-2.19-1.72H4.88A2.24,2.24,0,0,0,2.63,5.79v7.64a2.25,2.25,0,0,0,2.25,2.25H18.27c.33,1.21.63,2.31.73,2.72a4.1,4.1,0,0,0,2,2.34.73.73,0,0,0,.35.09.77.77,0,0,0,.66-.4A.75.75,0,0,0,21.69,19.42ZM4.88,14.18a.76.76,0,0,1-.75-.75V5.79a.75.75,0,0,1,.75-.74h6.38a.74.74,0,0,1,.73.57l2,8.56Zm10.87,6.34H3.16a1.29,1.29,0,0,1-1.29-1.29h0a1.29,1.29,0,0,1,1.29-1.29H15.75A1.29,1.29,0,0,1,17,19.23h0A1.29,1.29,0,0,1,15.75,20.52ZM6,8.11V6.46h4.28l.44,1.65Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BulldozerIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bulldozer'),
) as IconWithRender;

BulldozerIcon.displayName = 'BulldozerIcon';
BulldozerIcon.propTypes = Icon.propTypes;
BulldozerIcon.renderIcon = (props) => <BulldozerIcon {...props} />;
export default BulldozerIcon;
